import Vue from 'vue';
import Filters from './filters';
import Directives from './directives';
import Mixins from './mixins';
import './reset';

Vue.use(Filters);
Vue.use(Directives);
Vue.mixin(Mixins);
